module.exports = __webpack_public_path__ + "static/media/InstagramIcon.cae732c8.png";